import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeleteIcon } from "../../../../../common/icons/delete.svg";
import { ReactComponent as SettingsIcon } from "../../../../../common/icons/settings.svg";

type Props = {
  open: boolean;
  anchorEl: any;
  onClose: () => void;
  rowId: string;
  isRowEditable: boolean;
  onDeleteRow: (id: string) => void;
  onEditingRow: (id: string) => void;
  editingMode: boolean;
  systemItem: boolean;
};

export const ActionMenu = ({
  open,
  anchorEl,
  onClose,
  rowId,
  isRowEditable,
  onDeleteRow,
  onEditingRow,
  editingMode,
  systemItem,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
      <List dense disablePadding>
        {!editingMode && (
          <ListItem disablePadding>
            <ListItemButton
              sx={{ paddingLeft: "13px", paddingRight: "13px" }}
              onClick={() => {
                onEditingRow(rowId);
                onClose();
              }}
            >
              <ListItemIcon sx={{ minWidth: "13px", marginRight: "13px" }}>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>{t("common:edit")}</Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        )}
        {!systemItem && (
          <>
            <ListItem disablePadding>
              <ListItemButton
                sx={{ paddingLeft: "13px", paddingRight: "13px" }}
                disabled={!isRowEditable}
                onClick={() => {
                  onDeleteRow(rowId);
                  onClose();
                }}
              >
                <ListItemIcon sx={{ minWidth: "13px", marginRight: "13px" }}>
                  <DeleteIcon />
                </ListItemIcon>
                <ListItemText>
                  <Typography sx={{ color: "#C50631" }}>
                    {t("delete")}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </>
        )}
      </List>
    </Menu>
  );
};
